<template>
  <div class="laonlsec_fluid">
    <div class="laonlsec">
      <div class="hottop between">
        <div class="hot_spe w_800">
          <div class="hot_spe_ti between">
            <sub-title text="热门专长" />
            <div class="text_hover_shou">更多专长></div>
          </div>
          <div class="spe_list flex_start wrap">
            <div class="spe_item" v-for="(item, index) in majors" :key="index">
              {{item.name}}
            </div>
          </div>
        </div>
        <div class="hsr w_370" >
          <!-- <img src="../../../assets/question/bg2.png" /> -->
		  <div class="hot_spe_ti flex-col">
		    <sub-title text="咨询在线律师" />
			<div class="theitem flex mt30">
				<div class="hoticon FontBlue">快</div>
				<span class="FontSize14 FontGray">回复及时，响应迅速</span>
			</div>
			<div class="theitem flex">
				<div class="hoticon FontBlue">准</div>
				<span class="FontSize14 FontGray">一对一专享，服务更优质</span>
			</div>
			<div class="theitem flex ">
				<div class="hoticon FontBlue">专</div>
				<span class="FontSize14 FontGray">专业深度回复，解决问题更彻底</span>
			</div>
		  </div>
        </div>
      </div>
      <div class="flowcen between">
        <ul class="flowc_why w_370">
          <li>为什么要聘请律师？</li>
          <li>为什么要聘请律师？</li>
          <li>为什么要聘请律师？</li>
          <li>为什么要聘请律师？</li>
          <li>为什么要聘请律师？</li>
        </ul>
        <div class="onli_flow w_800">
          <sub-title text="在线律师咨询服务流程" />
          <div class="flow_list between">
            <div class="flow_item">
              <div><img src="../../../assets/lawyerOnline/tjwt.png" /></div>
              <div>提交问题</div>
            </div>
            <div class="fgjt">
              <img src="../../../assets/lawyerOnline/zsjt.png" />
            </div>
            <div class="flow_item">
              <div><img src="../../../assets/lawyerOnline/tjwt.png" /></div>
              <div>提交问题</div>
            </div>
            <div class="fgjt">
              <img src="../../../assets/lawyerOnline/zsjt.png" />
            </div>
            <div class="flow_item">
              <div><img src="../../../assets/lawyerOnline/tjwt.png" /></div>
              <div>提交问题</div>
            </div>
            <div class="fgjt">
              <img src="../../../assets/lawyerOnline/zsjt.png" />
            </div>
            <div class="flow_item">
              <div><img src="../../../assets/lawyerOnline/tjwt.png" /></div>
              <div>提交问题</div>
            </div>
          </div>
        </div>
      </div>
      <div class="lastbtm between">
        <div class="zxzx">
          <sub-title text="最新咨询" class="title" />
          <ul class="list">
            <li v-for="(item, index) in 5" :key="index">
              {{ `为什么要聘请律师？ ` | toEllipsisFilter(31) }}
              <span>3分钟前</span>
            </li>
          </ul>
        </div>
        <div class="zxjd">
          <sub-title text="最新解答" class="title" />
          <ul class="list">
            <li v-for="(item, index) in 5" :key="index">
              {{
                `离婚时，男方以女方父母借给他做生意的三十万不还为要挟，逼迫女方签 `
                  | toEllipsisFilter(31)
              }}
              <span>3分钟前</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
  data(){
	return{
		majors:[]  
	}
  },
  created() {
  	this.$http.home.majors().then( res =>{
		this.majors = res.data
	})
  }
};
</script>

<style lang="scss" scope>
.laonlsec_fluid {
  width: 100%;
  background-color: #f8f8f8;
  .w_370 {
    width: 370px;
  }
  .w_800 {
    width: 800px;
  }

  .laonlsec {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    .hottop {
      align-items: flex-start;
      height: 220px;
      .hot_spe {
        background: #ffffff;
        height: 100%;
        box-shadow: 0px 1px 14px 0px rgba(0, 0, 0, 0.08);
        padding: 20px 20px 50px;
        .hot_spe_ti {
          font-size: 14px;
          color: #666666;
          margin-bottom: 10px;
        }
        .spe_list {
          .spe_item {
            width: 102px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #e8e8e8;
            border-radius: 2px;
            margin-right: 20px;
            margin-top: 20px;
            &:hover {
              border: 1px solid #0465ea;
              color: #0465ea;
            }
          }
        }
      }
      .hsr {
		  width: 370px;
		  height: 220px;
		  padding: 24px 20px;
		  background: url(../../../assets/question/bg2.png) ;
		  background-position: center;
		  background-size: cover;
		  .hot_spe_ti{
			  .theitem{
				align-items: center;  
				margin-bottom: 11px;
				padding-left: 15px;
			  }
			  .hoticon{
				  width: 32px;
				  height: 32px;
				  line-height: 32px;
				  margin-right: 13px;
				  text-align: center;	
				  border: 1px solid #0465EA;
				  border-radius: 50%;
			  }
		  }
      }
    }
    .flowcen {
      align-items: flex-start;
      margin-top: 24px;
      height: 210px;

      .flowc_why {
        height: 100%;
        background: url("../../../assets/lawyerOnline/why_bg.png") no-repeat
          100% 100%;
        box-shadow: 0px 1px 14px 0px rgba(0, 0, 0, 0.08);
        padding: 26px 35px;
        color: #999999;
        li {
          list-style: disc;
          line-height: 32px;
          cursor: pointer;
          &:hover {
            color: #0465ea;
          }
        }
      }
      .onli_flow {
        height: 100%;
        padding: 24px;
        background-color: #fff;
        .flow_list {
          padding: 24px 24px 0;
          color: #666666;
          .flow_item {
            text-align: center;
            img {
              width: 70px;
              height: 70px;
              border-radius: 50%;
              margin-bottom: 20px;
            }
          }
          .fgjt {
            position: relative;
            top: -20px;
            img {
              width: 50px;
              height: 8px;
            }
          }
        }
      }
    }

    .lastbtm {
      width: 100%;
      padding: 21px;
      margin-top: 24px;
      background-color: #fff;
      box-shadow: 0px 1px 14px 0px rgba(0, 0, 0, 0.08);
      align-items: flex-start;
      .zxzx,
      .zxjd {
        width: 49%;
        .title {
          margin-bottom: 6px;
        }
        .list {
          font-size: 14px;
          padding-left: 18px;
          li {
            cursor: pointer;
            list-style: disc;
            line-height: 14px;
            margin-top: 16px;
            color: #666666;
            span {
              color: #999999;
            }
            &:hover {
              color: #0465ea;
            }
          }
        }
      }
    }
  }
}
</style>